import { TActiveIntegrationTypes } from '@core/modules/integrations/integrations'
import { ReactElement } from 'react'
import SvgMicrosoftIcon from '@assets/images/microsoft-365.svg?react'
import SvgGoogleIcon from '@assets/images/google-workspace-fd.svg?react'
import SvgCrowdStrikeIcon from '@assets/images/crowdstrike.svg?react'
import { keyErrorInfo } from '@core/modules/issues/constants'

export const generateIntegrationError = (
    error: string | undefined | boolean
) => {
    if (error === keyErrorInfo.permissionsError.key) {
        return keyErrorInfo.permissionsError.message
    }
    if (error === keyErrorInfo.encryptionError.message) {
        return error
    }
    return 'There was a problem configuring the integration. Please tap the Enable integration button to start over.'
}

export const integrationDetailsByType: Partial<
    Record<
        TActiveIntegrationTypes,
        {
            icon: ReactElement
            isBeta: boolean
            assetId: string
        }
    >
> = {
    microsoft: {
        icon: <SvgMicrosoftIcon />,
        isBeta: false,
        assetId: 'pt_mic_3yidnrpZ',
    },
    google: {
        icon: <SvgGoogleIcon />,
        isBeta: false,
        assetId: 'pt_google_a91dbce8',
    },
    crowdstrike: {
        icon: <SvgCrowdStrikeIcon />,
        isBeta: false,
        assetId: 'pt_csf_s1x1htm7',
    },
}
